import React, { useState } from 'react';

const SignUpForm = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Account created with mobile number:', mobileNumber);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="flex max-w-4xl w-full bg-white shadow-lg rounded-md">
        
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl font-bold text-center">Create an account</h2>
          <form onSubmit={handleSubmit} className="mt-4">
            <div className="mb-4">
              <label htmlFor="fullName" className="block text-gray-700">Full name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Your full name"
                className="w-full p-3 mt-2 border rounded-md"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-700">Email id</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="eg. example@gmail.com"
                className="w-full p-3 mt-2 border rounded-md"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="mobileNumber" className="block text-gray-700">Mobile Number</label>
              <input
                type="text"
                id="mobileNumber"
                name="mobileNumber"
                placeholder="Your valid mobile number"
                className="w-full p-3 mt-2 border rounded-md"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700">+91</label>
            </div>

            <button type="submit" className="w-full p-3 bg-blue-500 text-white rounded-md">
              Get OTP
            </button>

            <div className="mt-4 text-center">
              <p>Already have an account? <a href="/login" className="text-blue-500">Sign In</a></p>
            </div>
          </form>
        </div>

        <div className="hidden md:block w-1/2">
          <img src="//dm6g3jbka53hp.cloudfront.net/static-images/signup-pet-09042021.jpg" alt="" className="w-full h-full object-cover rounded-r-md"/>
        </div>
      </div>
    </div>
  );
};

export default SignUpForm;
